import React, { useEffect } from 'react';
import './Modal.scss';
import PropTypes from 'prop-types';

export default function Modal({
	isOpen,
	onClose,
	children,
	title,
	bodyClassName = '',
}) {
	useEffect(() => {
		if (!isOpen) return;

		const handleKeyDown = (e) => {
			if (e.key === 'Escape') {
				onClose();
			}
		};

		document.addEventListener('keydown', handleKeyDown);
		document.body.style.overflow = 'hidden';

		return () => {
			document.removeEventListener('keydown', handleKeyDown);
			document.body.style.overflow = '';
		};
	}, [isOpen, onClose]);

	if (!isOpen) return null;

	const handleOverlayClick = (e) => {
		if (e.target === e.currentTarget) {
			onClose();
		}
	};

	return (
		<div
			className={
				bodyClassName
					? `modal-overlay ${bodyClassName}`
					: 'modal-overlay'
			}
			onClick={handleOverlayClick}
			role="presentation"
		>
			<div
				className="modal-container"
				role="dialog"
				aria-modal="true"
				aria-labelledby="modal-title"
			>
				<div className="modal-header">
					<span
						id="modal-title"
						className="modal-title"
					>
						{title}
					</span>
					<button
						type="button"
						onClick={onClose}
						className="modal-close"
						aria-label="Close modal"
					>
						Close
					</button>
				</div>

				<div className={`modal-body`}>{children}</div>
			</div>
		</div>
	);
}

Modal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	children: PropTypes.node,
	title: PropTypes.string,
	bodyClassName: PropTypes.string,
};
